import { icons } from "../../assets/icons";

export const sidebarOptions = [
  {
    icon: icons.dashboardActive,
    title: "Dashboard",
    link: "/dashboard",
    showTo: ["Store", "L1", "L2", "Finance"],
  },
  {
    icon: icons.reconciliation,
    title: "Petty Cash",
    link: "/petty-cash",
    showTo: ["Store", "L1", "L2", "Finance"],
  },
  {
    icon: icons.vouchers,
    title: "Vouchers",
    link: "/vouchers",
    showTo: ["Store", "L1", "L2", "Finance"],
  },
  {
    icon: icons.pettyCash,
    title: "Cash Deposit",
    link: "/cash-deposit",
    showTo: ["Store", "L1", "L2", "Finance"],
  },
  {
    icon: icons.reports,
    title: "View Requests",
    link: "/request",
    showTo: ["Store", "L1"],
  },
  {
    icon: icons.reports,
    title: "SAP Reports",
    link: "/sap-reports",
    showTo: ["Finance"],
  },
  {
    icon: icons.reports,
    title: "Voucher Reports",
    link: "/voucher-reports",
    showTo: ["Finance"],
  },
];
